import React, { useEffect, useState } from 'react';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CloseIcon from '@material-ui/icons/Close';
import swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { deleteDashboardPhoto, uploadDashboardPhoto } from 'redux/thunks/dashboard';
import { addFavoriteDashboard, removeFavoriteDashboard } from 'redux/thunks/user';
import CircularProgress from '@material-ui/core/CircularProgress';
import Lightbox from 'react-awesome-lightbox';
import 'react-awesome-lightbox/build/style.css';
import { Grid, Typography } from '@material-ui/core';
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import FavoriteIcon from '@material-ui/icons/Favorite';

const Title = (props) => {
    const { dashboardName, ownerName, siteId, dashboardId, imageUrl, imageLoading, allowEdit, email, hits, contributors } = props;
    const [showLightbox, setShowLightbox] = useState(false);
    const dispatch = useDispatch();
    const [favorite, setFavorite] = useState(false);
    const favoriteDashboards = useSelector((state) => state.user.favoriteUserDashboards);

    const handlePhotoUpload = (event) => {
        event.preventDefault();

        const reader = new FileReader();
        const uploadedFile = event.target.files[0];

        reader.onloadend = () => {
            dispatch(uploadDashboardPhoto(siteId, dashboardId, uploadedFile));
        };
        reader.readAsDataURL(uploadedFile);
    };

    const clickUpload = () => {
        document.getElementById('dashboardImage').click();
    };

    const deleteImage = async () => {
        const result = await swal.fire({
            title: 'Are you sure?',
            text: 'This will remove the image from this dashboard.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it.',
        });

        if (result.value) {
            dispatch(deleteDashboardPhoto(siteId, dashboardId));
        }
    };

    const handleUpdateFavoriteDashboard = (isFavorite) => {
        if (isFavorite) {
            const dashboard = {
                contributors: contributors,
                dashboardId: dashboardId,
                email: email,
                hits: hits,
                name: dashboardName,
                owner: ownerName,
                siteId: siteId,
            };
            dispatch(addFavoriteDashboard(dashboard)).then(() => {
                const favDashboardId = dashboardId;
                if (favoriteDashboards.filter((e) => e.dashboardId === favDashboardId).length > 0) {
                    setFavorite(true);
                }
            });
        } else {
            dispatch(removeFavoriteDashboard(dashboardId)).then(() => {
                const unFavDashboardId = dashboardId;
                if (favoriteDashboards.filter((e) => e.dashboardId === unFavDashboardId).length === 0) {
                    setFavorite(false);
                }
            });
        }
    };

    useEffect(() => {
        for (let x = 0; x < favoriteDashboards.length; x++) {
            if (dashboardId === favoriteDashboards[x].dashboardId) {
                setFavorite(true);
                break;
            }
        }
    }, [dispatch, favoriteDashboards, dashboardId]);

    return (
        <>
            <div className='title'>
                {imageLoading && (
                    <div className='title__loader'>
                        <CircularProgress />
                    </div>
                )}
                {imageUrl && !imageLoading && (
                    <div className='title__image-container'>
                        {allowEdit && <CloseIcon className='title__image-container--close-icon' onClick={deleteImage} />}
                        <img src={imageUrl} alt='upload-preview' className='title__image' onClick={() => setShowLightbox(true)} />
                    </div>
                )}
                {allowEdit && !imageLoading && !imageUrl && (
                    <div className='title__image-container'>
                        <input
                            className='displayNone'
                            id='dashboardImage'
                            type='file'
                            accept='image/*'
                            name='somename'
                            size='chars'
                            onChange={handlePhotoUpload}
                        />
                        <div className='title__photo' onClick={clickUpload}>
                            <div>
                                <AddCircleOutlineIcon />
                            </div>
                            <div className='uploadPhoto'>Upload Photo</div>
                        </div>
                    </div>
                )}
                <div className='left-section'>
                    <Typography variant='h4' className='dashboard-name'>
                        {dashboardName}
                        {favorite ? (
                            <FavoriteIcon color='secondary' className='favIcon' onClick={() => handleUpdateFavoriteDashboard(!favorite)} />
                        ) : (
                            <FavoriteBorderOutlinedIcon color='action' className='favIcon' onClick={() => handleUpdateFavoriteDashboard(!favorite)} />
                        )}
                    </Typography>
                    <Grid container>
                        <Typography variant='subtitle1' className='owner-label'>
                            Owner:
                        </Typography>
                        <Typography variant='subtitle1' className='owner-label'>
                            {ownerName}
                        </Typography>
                    </Grid>
                </div>
            </div>
            {showLightbox && imageUrl && <Lightbox image={imageUrl} onClose={() => setShowLightbox(false)} />}
        </>
    );
};

export default Title;
